import type { PageMode } from '../../constants/page-mode';
import type { FireAnalyticsEvent } from '../../types';

export type PageModeToggledProps = {
	from: PageMode;
	to: PageMode;
	// How the mode change was triggered: a user click on the toggle ('manual-toggle'), or the
	// reserved-for-later 'intent-detection' / 'deep-link' sources that reuse the same action.
	source: 'manual-toggle' | 'intent-detection' | 'deep-link';
	searchSessionId?: string | null;
};

// TO DO: new event, needs to be enriched with the attributes we need
export const onPageModeToggled = ({
	from,
	to,
	source,
	searchSessionId,
}: PageModeToggledProps): FireAnalyticsEvent => ({
	eventType: 'ui',
	action: 'switched',
	actionSubject: 'searchPageMode',
	attributes: {
		additionalAttributes: {
			from,
			to,
			source,
			searchSessionId,
		},
	},
});
